module.exports = __webpack_public_path__ + "static/media/5DPO17.4777f0e4.jpg";